const zh_Hk = {
  9000001: " 2023聖誕杯",
  9000002: "SuperEx合約錦標賽",
  9000003: "贏取30,000USDT競賽獎金",
  9000004: "參賽人數",
  9000005: "已解鎖獎池（USDT）",
  9000006: "交易量排名資格賽",
  9000007: "盈利率排名資格賽",
  9000008: "盈利額排名資格賽 ",
  9000009: `交易量排名賽，解鎖最高 <span style="color: #ffc72b;">20,000</span> USDT 獎金池`,
  9000010: "根據參賽人數解鎖對應獎池，參賽人數越多解鎖獎池越大，最高20,000USDT獎金池 ",
  9000011: "獎池金額",
  9000012: "活動期間每天10:00（UTC）更新",
  9000013: "獎勵預估",
  9000014: "期間纍計合約交易金額",
  9000015: "獎勵規則 ",
  9000016: "根據參賽人數解鎖對應獎池，參賽人數越多解鎖獎池越大，最高20,000USDT獎金池",
  9000017: "獎池金額（USDT）",
  9000018: "活動盈利率排名",
  9000019: "報名",
  9000020: "活動盈利額排名",
  9000021: "已結束",
  9000022: `盈利率排名賽，瓜分 <span style="color: #ffc72b;">{moneyPond}</span> USDT 獎金`,
  9000023: `盈利額排名賽，瓜分 <span style="color: #ffc72b;">{moneyPond}</span> USDT 獎金`,
  9000024: "累计合約盈利率",
  9000025: "纍計合约盈利金額",
  9000026: "未開始",
  9000027: "參賽用戶盈利額排名前50名獲得獎勵，可參考交易排名獎勵規則獲取贈金獎勵",
  9000028: "參賽用戶盈利率排名前50名可獲得獎勵，可參考交易排名獎勵規則獲取獎勵",
  9000029: "活動交易額排名",
  9000030: "註冊成功",
  9000031: "下載App",
  9000032: "返回首頁",

  //合约交易积分
  9100001: "攢積分",
  9100002: "得空投",
  9100003: "兌獎勵",
  9100004: "積分餘額",
  9100005: "明細",
  9100006: "簽到積分",
  9100007: "交易積分",
  9100008: "邀請積分",
  9100009: "獎勵積分",
  9100010: "幸運抽獎",
  9100011: "獲取積分",
  9100012: "積分規則",
  9100013: "積分明細",
  9100014: "您需要報名才能參與此活動，點擊即可參與",
  9100015: "已連續交易 {day} 天並獲得 {num} 積分",
  9100016: "今日已得 {num} 積分",
  9100017: "積分獎池",
  9100018: "每次抽獎消耗 {point} 積分，每天最多抽 {num} 次",
  9100019: "今日抽獎次數",
  9100020: "用戶",
  9100021: "積分",
  9100022: "積分餘額不足",
  9100023: "積分餘額不足，請獲取積分後再參與抽獎",
  9100024: "抽獎次數已達上限",
  9100025: "今日抽獎次數已達上限，請明日再試。",
  9100026: "如何獲得積分",
  9100027: "報名參與合約交易獲積分活動，才能獲得積分",
  9100028: "參與報名成功",
  9100029: "您已報名參與合約交易獲積分活動，去交易獲得更多積分吧（將不再享受返傭返現獎勵）",
  9100030: "取消報名後，將不再獲得積分，您確定要取消報名嗎？",
  9100031: "交易積分活動中心",
  9100032: "獲取積分",
  9100033: "您需要報名才能參與此活動，點擊即可參與",
  9100034: "連續參與合約交易即可獲得積分",
  9100035: "用戶在合約市場產生的所有交易行為即可獲取積分",
  9100036: "排行榜積分",
  9100037: "每日交易排行榜前五給與額外的獎勵積分",
  9100038: "被邀請人產生積分，邀請人可獲得獎勵積分",
  9100039: '{guy} 已經中獎<span style="color:#D9A31A"> {num} 積分</span>',
  9100040: "立即抽獎",
  9100041: "恭喜您獲得了",
  9100042: "全部類型",
  9100043: "留在此頁",
  9100044: "參與報名",
  9100045: "繼續交易",
  9100046: "暫無正在進行的活動，敬請期待...",
  9100047: "兌SCS代幣",
  9100048: "",
  9100049: "",

  9100050: "日期",
  9100051: "起始時間",
  9100052: "結束時間",
  9100053: "到",
  9100054: "類型",

  9100055: "可獲積分=交易額*1%（難度隨著平台總交易量的上升會進一步調整）",
  9100056: "例如：用戶使用保證金100USDT*100X=10000U的倉位",
  9100057: "那麼只需要100USDT的保證金即可獲得100積分",
  9100058: "交易積分是獲取平台代幣SCS的唯一渠道",
  9100059: "額外獎勵積分=當日積分總額*名次獎勵比例",
  9100060: "名次",
  9100061: "第一名",
  9100062: "第二名",
  9100063: "第三名",
  9100064: "第四名",
  9100065: "第五名",
  9100066: "被邀請人產生積分，邀請人可獲得獎勵積分",
  9100067: "等級係數",
  9100068: "計算公式：獲得推廣積分= 被邀請人獲得積分 * 等級係數",
  9100069: "等級係數會根據實際狀況進行調整",
  9100070: "例如：用戶B參與積分活動，其邀請人為用戶A，且用戶A邀請數等級已達到Level3，用戶B累計獲得積分=360,000；",
  9100071: "那麼用戶A累計可獲的推廣積分=360000* 30%=108,000",
  9100072: "獎勵係數",
  9100073: "1个交易用戶 ",
  9100074: "交易量達到500W",
  9100075: "交易量達到2000W",

  9100076: "劃轉",

  //热币
  9100080: "距離活動結束",
  9100081: "點擊「報名參加」贏大獎",
  9100082: "查看規則",
  9100083: "報名參加",
  9100084: "活動",
  9100088: "去交易",
  9100089: "去充值",
  9100090: "您已報名此活動",

  9100091: "本次活動已結束，敬請期待下一次活動！",
  9100092: "活動未開始，敬請期待",
  9100093: "",
  9100094: "",

  //api key
  9100105: "創建API Key",
  9100106: "查看 API 文檔",
  9100107: "一體化交易系統",
  9100108: "創建/管理 API Key",
  9100109: "部署API",
  9100110: "交易和請求",
  9100111: "領先的數字資產交易平台",
  9100112: "豐富的數字資產交易及資產管理服務，滿足多樣化交易需求。",
  9100113: "提供更好的服務",
  9100114: "更優的交易費率、更高的交易金額、更靈活的賬戶管理功能等。",
  9100115: "千萬用戶信賴之選",
  9100116: "確保安全的交易環境，提供專業的客戶支持，助您在數字資產的世界中穩步前行。",
  9100117: "如何在 SuperEx 創建 API Key？",
  9100118: "SuperEx 的 API 文件在哪裡可以查看？",
  9100119: "在 SuperEx 交易發現了問題怎麼辦？",
  9100120: "如何使用 SuperEx 的 API？",
  9100121: "接入 SuperEx API，交易更快更流暢",
  9100122: "您在登錄的狀態下，鼠標懸停於頭像-「API管理」，點擊「創建API Key」，創建您在 SuperEx 的 API Key。註:如果您未登錄的話，需要您先登錄您在 SuperEx 的賬號。也可以從底部導航欄「APIs」進入，創建您在SuperEx的API Key。",
  9100123: `您可以點擊<a style="color:#d1a53e;text-decoration:underline !important;font-size: 14px;font-family: Lato-Regular, Lato;font-weight: 400;" href="https://docs-api.superex.com/en/quickStart.html">API文档</a>，查看 SuperEx 的API文档`,
  9100124: "使用過程中如有問題或者建議，您可選擇以下方式聯繫我們： <br>通過官網的「幫助中心」或者發送郵件至客服郵箱support@superex.com聯繫客服。",
  9100125: `使用 SuperEx 的API，您首先需要：<br>
註冊並登錄 SuperEx 帳戶。<br>
創建一個API Key，這會為您生成一個access_key和secret_key。<br>
使用此access_key和secret_key來簽名您的請求。<br>
根據您的需求，您可以使用 SuperEx 提供的不同API，如市場數據API、交易API、賬戶API等。每次請求時都需要遵循API文檔中的指示，並確保您的請求有適當的HTTP頭和簽名。`,
  9100126: "API密鑰管理",
  9100127: "創建新API密鑰",
  9100128: "備註名",
  9100129: "請輸入備註名",
  9100130: "權限設定（可多選）",
  9100131: "讀取",
  9100132: "交易",
  9100133: "綁定IP地址（選填）",
  9100134: "多個IP地址請用英文逗號隔開，最多填寫10個地址",
  9100135: "我已閱讀並同意",
  9100136: "我已閱讀並同意API用戶風險提示",
  9100137: "創建",
  9100138: 'SuperEx為您提供了強大的API，您可以通過API使用行情查詢、自動交易等服務。通過<a style="font-size: 14px;font-family: Lato-Regular, Lato;font-weight: 400;text-decoration:underline !important;color:#d1a53e;" href="https://docs-api.superex.com/en/quickStart.html">API文檔</a>查看如何使用。',
  9100139: "每個用戶最多創建10組API密鑰",
  9100140: "未綁定IP的API密鑰，將在90天後自動失效。如長期使用，您可在下方「我的API密鑰 —— 操作—— 續簽」，將您的API密鑰有效期順延90天。已綁定IP的 API密鑰無有效期限制。",
  9100141: "我的API Key",
  9100142: "權限",
  9100143: "綁定IP地址",
  9100144: "續簽",
  9100145: "創建API Key需要您向現貨錢包充值任意金額激活賬戶",
  9100146: "確認續簽當前API Key",
  9100147: "請不要洩露您的Access Key及Secret Key，以免造成資產損失。",
  9100148: "出於安全考慮，建議為API密鑰綁定IP，每個API密鑰最多綁定10個IP地址。單個IP地址直接填寫，多個IP地址用半角逗號分隔，如：192.168.1.1,192.168.1.2",
  9100149: "續簽成功後到期時間會重新計算。如果您長期使用API Key，建議綁定IP地址，綁定後API Key不會失效同時也更加安全。",
  9100150: "確認刪除當前API Key？",
  9100151: "您需要了解以下風險：",
  9100152: "API Key與您的賬號安全緊密相關，任何知曉您API Key的第三方均有可能控制您賬戶資產，因此請您妥善保管，請不要向任何第三方透露您的API Key，並不上傳至第三方網站和論壇。",
  9100153: "因您個人原因導致API Key洩露而涉及的包括但不限於資產安全問題、經濟損失問題等，您自行承擔由此產生的全部責任，我們不對此承擔責任。",
  9100154: "風險提示",
  9100155: "我已知悉並願意承擔風險",
  9100156: "我已保存",
  9100157: "權限設定",
  9100158: "密鑰僅顯示一次,遺失後不可找回,請務必妥善保存。",
  9100159: "請不要洩露您的Access Key及Secret Key，以免造成資產損失。",
  9100160: "如果您忘記了Secret Key，請刪除該密鑰對並申請新的密鑰對。",
  9100161: "我們提供功能強大的API，幫助您高效地將交易功能整合至應用中。API分為賬戶、交易和行情三類，您可根據需求配置相應權限，並通過API實現自動交易",
  9100162: "創建時間",
  9100163: "創建新API密鑰",
  9100164: "編輯",
  9100165: "到期時間",
  9100166: "刪除",
  9100167: "創建成功",
  9100168: "溫馨提示",
  9100169: "知道了",
  9100170: "API用戶風險提示",
  9100171: "IP地址格式不正確",
  9100172: "",
  //自由区二维码分享页面
  9100095: "自由區上幣，開啟財富自由",
  9100096: "打開APP",
  9100097: "",
  9100098: "",

  //代理商
  101738: "成為 SuperEx 代理商享高額返傭",
  101739: "邀請好友來 SuperEx 交易，可獲得50%手續費返傭，好友進行合約交易後，您可享有返傭。",
  101740: "成為代理商",
  101741: "如何獲得佣金？",
  101742: "申請成為代理商",
  101743: "擁有社群、媒體等資源即可申請代理商，申請成功後，您可升級為代理商",
  101744: "推廣 SuperEx",
  101745: "將您的邀請連結分享給您的社群、粉絲或您的其他管道進行宣傳曝光",
  101746: "獲得佣金收益",
  101747: "新用戶透過您的邀請連結註冊並交易，您可以獲得佣金",
  101748: "我能賺取多少佣金？",
  101749: "邀請用戶來 SuperEx 交易，您可以獲得好友手續費的20%作為邀請獎勵。",
  101750: "您成為 SuperEx 代理商，您還可以獲得50%的代理商返傭獎勵",
  101751: "為什麼成為 SuperEx 代理商？",
  101752: "高額返傭",
  101753: "50%手續費返傭",
  101754: "流量扶持",
  101755: "專業流量扶持，輕鬆取得效益",
  101756: "品牌加持",
  101757: "全球線下活動，定制聯合禮品周邊",
  101758: "全球線下活動",
  101759: "SuperEX全球線下粉絲會，業界頂尖會議，全方位扶持每一位代理商，並協助提升收益",
  101760: "審核未通過",
  101761: "代理商",
  101762: "渠道管理",
  101763: "創建渠道",
  101764: "所屬渠道",
  101765: "推廣方式",
  101766: "渠道名稱",
  101767: "創建時間",
  101768: "編輯",
  101769: "合約返傭比例",
  101770: "現貨返傭比例",
  101771: "推廣管理",
  101772: "創建代理商邀請碼",
  101773: "邀請碼",
  101774: "剩餘可創建推廣鏈接數量",
  101775: "邀請人數",
  101776: "代理商邀請碼",
  101777: "代理商邀請人數",
  101778: "常規邀請碼數量",
  101779: "常規邀請人數",
  101780: "邀請鏈接",
  101781: "常規管道",
  101782: "數據看板",
  101783: "入金人數",
  101784: "交易額",
  101785: "佣金",
  101786: "所屬邀請碼",
  101787: "移動邀請關係",
  101788: "合約報表",
  101789: "現貨報表",
  101790: "交易筆數",
  101791: "結算中心",
  101792: "合約結算",
  101793: "現貨結算",
  101794: "預估佣金",
  101795: "提現記錄",
  101796: "查看資產",
  101797: "已提現金額",
  101798: "累計佣金",
  101799: "當前代幣暫不滿足提現金額，您可以邀請更多用戶進行交易以獲得獎勵金。",
  101800: "合約數據概覽",
  101801: "現貨數據概覽",
  101802: "合約明細",
  101803: "現貨明細",
  101804: "全部方向",
  101805: "代理商預估佣金",
  101806: "用戶預估佣金",
  101807: "成交時間",
  101808: "詳細規則請查看 SuperEx 公告",
  101809: "代理商計畫申請表單",
  101810: "您的語言",
  101811: "您在哪個國家？ （例如：伊朗）",
  101812: "您的主要平台/頻道時什麼？",
  101813: "您在平台/社群媒體/網站上有多少追蹤者/粉絲/用戶？",
  101814: "填寫您的主要平台/頻道連結（輸入完整的URL）",
  101815: "其他社交管道/網站連結（輸入完整的URL）",
  101816: "您的名字",
  101817: "填寫快速與您聯繫的社群媒體管道（例如：Telegram id @xxx）",
  101818: "您是從哪裡了解到代理商計劃？",
  101819: "朋友",
  101820: "您可以與我們分享的其他信息，例如關於您自己的和您頻道簡單介紹",
  101821: "太棒了",
  101822: "您已成功完成SuperEx代理商申請。 通過審核後，我們將會通過電子郵件通知您。",
  101823: "時間段的跨度不能超過3個月",
  101824: "操作成功",
  101825: "全部提現",
  101826: "已提現",
  101827: "當前代幣暫不滿足提現金額，您可以邀請更多用戶進行交易以獲得獎勵金。",
  101828: "用戶管理",
  101829: "用戶ID",
  101830: "合約返現比例",
  101831: "現貨返現比例",
  101832: "註冊時間",
  101833: "交易明細",
  101834: "買入開多",
  101835: "賣出開空",
  101836: "賣出平多",
  101837: "買入平空",
  101838: "提現時間",
  101839: "提現幣種",
  101840: "提現數量",
  101841: "用戶傭金",
  101842: "可提現金額",
  101843: "提現",
  101844: "社區",
  101845: "郵箱（此郵箱將用於接收代理商訊息，如果未發現驗證訊息，請查閱您的垃圾郵箱）",
  101846: "驗證碼",
  101847: "申請正在審核中，請耐心等待。 通過審核後，我們將會透過電子郵件通知您。",
  101848: "抱歉，您的代理商申請未通過",
  101849: "重新申請",
  101850: "數據概覽",
  101851: "代理商合約返傭比例",
  101852: "代理商現貨返傭比例",
  101853: "您已被取消代理商資格，如有疑問請聯絡管理員",
  101854: "全部時間",
  101855: "昨天",
  101856: "本月",
  101857: "上月",
  101858: "交易人數",
  101859: "總入金",
  101860: "請選擇邀請碼",
  101861: "總收益",
  101862: "合約佣金",
  101863: "現貨佣金",
  101864: "待提現",
  101865: "已提現",
  101866: "待解鎖",
  101867: "*佣金收益需提現至我的現貨帳戶才能使用",
  101868: "提現確認",
  101869: "您是否確認要將所有代幣全部提現到我的現貨帳戶？",
  101870: "當前代幣暫不滿足提現金額，您可以邀請更多用戶進行交易以獲得獎勵金。",
  101871: "已解鎖",
  101872: "已衝正",
  101873: "已取消代理商資格",
  101874: "已為代理商",
  101875: "渠道數據概覽",
  101876: "用戶數據",
  101877: "到雲錢包合約帳戶",
  101878: "到雲端錢包現貨帳戶",
  101879: "現貨交易明細",
  101880: "合約交易明細",
  101881: "合約結算中心",
  101882: "現貨結算中心",
  101883: "效果報表",
  101884: "請選擇語言",
  101885: "請輸入您的答案",
  101886: "請選擇渠道名稱",
  101887: "佣金提現",
  101888: "請輸入渠道名稱",
  101889: "請選擇推廣方式",
  101890: "請輸入備註內容",
  101891: "可提現資產",
  101892: "確認提現",
  101893: "設定用戶合約返現比例",
  101894: "設定用戶現貨返現比例",
  101895: "合約效果報表",
  101896: "現貨效果報表",
  101897: "折合(USDT)",
  101898: "提現到雲端錢包",
  101899: "確定將現貨佣金全部提現到雲端錢包嗎？",
  101900: "查看資金",
  101901: "全部幣種",
  101902: "未提現",
  101903: "總佣金",
  101904: "請選擇國家或地區",
  101905: "請填寫驗證碼",
  101906: "代理商系統",
  101907: "謝謝",
  101908: "您的申請已送出。 我們一般在2-3個工作天內審核你的訊息，通過審核後將生效你的返傭",
  //代理商拉新
  92000000:'活動倒計時',
  92000001:'參與方式',
  92000002:'您需要確保完成任務的賬號與您在當前頁面的註冊/登錄賬號保持一致，這樣才有機會贏得獎勵。',
  92000003:'等待任務驗證',
  92000004:'應 <span style="color:#000922;font-weight:500;">{brokerName}</span> 邀請註冊 SuperEx 帳戶，可解鎖限時迎新獎勵!',
  92000005:'從{time} 開始',
  92000006:'至{time} 完成',
  92000007:'任務完成驗證最多需要 7 工作日，請耐心等待。',
  92000008:'活動結束後約 7 天內',
  92000009:'驗證任務無誤後，活動獎勵將在活動結束後7個工作日內發放至賬戶。',
  92000010:'使用 <span style="color:#000922;font-weight:400;">{brokerName}</span> 的邀請鏈接註冊',
  92000011:'條款與條件',
  92000012:'活動進行中',
  92000013:'無法參與此活動',
  92000014:'活動已結束',
  92000015:'領取獎勵',
  92000016:'立即登錄',
  92000017:'請設置暱稱',

  92000018:'備註',
  92000019:'該項為必填項',
  92000020:'保存',
  92000021:'分享海報',
  92000022:'最大',
  92000023:'編輯所屬頻道',
  92000024:'創建所屬渠道',
  92000025:'該渠道下無邀請碼',
  92000026:'',
  92000027:'',
  92000028:'',
  92000029:'',
  92000030:'',
};
export default zh_Hk;



// WEBPACK FOOTER //
// ./src/i18n/langs/languageJame/zh-HK.js